import angular from 'angular';

import EditUserProfileCtrl from '../dashboard/manage/users/EditUserProfileCtrl';
import editUrl from '../dashboard/manage/users/edit.html';
import { accessLevels } from '../constants';
import managePreviewRedirects from '../account/managePreviewRedirects';
import { STATE_DEFINITION_COMMON } from '../users/constants';

import LaborCostSettingsImport from './services/LaborCostSettings';
import LaborSettingsImport from './models/LaborSettings';
import LaborCostCtrl from './LaborCostCtrl';
import currencySelectorComponent from './../components/components/currencySelectorComponent';
import laborCostSettingsComponent from './components/laborCostSettingsComponent';
import laborCostUsersComponent from './components/laborCostUsersComponent';
import laborCostNoAccessComponent from './components/laborCostNoAccessComponent';
import laborCostPreviewComponent from './components/laborCostPreviewComponent';
import indexUrl from './index.html';

const laborCostModule = angular.module('sling.labor-cost', []);

laborCostModule.config(($stateProvider) => {
  $stateProvider.state('labor-cost', {
    url: '/labor-cost',
    template: '<ui-view/>',
    data: {
      access: accessLevels.manager,
    },
    resolve: {
      personaCollection(PersonaCollection) {
        'ngInject';

        return PersonaCollection.loadData();
      },
    },
  });

  $stateProvider.state('labor-cost.settings', {
    templateUrl: indexUrl,
    controller: 'LaborCostCtrl',
    controllerAs: 'ctrl',
    reloadOnSearch: false,
    data: {
      title: 'Labor Cost Settings',
    },
    resolve: {
      personaCollection(PersonaCollection) {
        return PersonaCollection.loadData();
      },
      hasSettingsAccess(LaborCostSettings, $state, $q) {
        return LaborCostSettings.loadData().catch(() => {
          if (LaborCostSettings.noAccess) {
            $state.go('labor-cost.no-access', {}, { reload: true });
            return $q.reject('redirect');
          }
        });
      },
    },
  });

  $stateProvider.state('labor-cost.settings.tabs', {
    url: '/settings?tab',
    reloadOnSearch: false,
    views: {
      locations: {
        template:
          "<manage-locations search=\"ctrl['search-locations']\" disable-bulk-actions=\"true\" hide-header=\"true\" column-subset=\"['name', 'projectedSales', 'budget', 'hoursCap', 'options']\" display-my-groups=\"!$root.authentication.user.isAdmin\"></manage-locations>",
      },
      positions: {
        template:
          "<manage-positions search=\"ctrl['search-positions']\" disable-bulk-actions=\"true\" hide-header=\"true\" column-subset=\"['name', 'memberCount', 'baseWage', 'options']\"></manage-positions>",
      },
      employees: {
        template: '<labor-cost-users search="ctrl[\'search-employees\']"></labor-cost-users>',
      },
    },
    params: {
      tab: 'employees',
    },
    resolve: {
      projectedSales(SalesService, $transition$) {
        if ($transition$.targetState().tab === 'locations') {
          return SalesService.fetchAllDefaultSales();
        }
      },
    },
  });

  $stateProvider.state('labor-cost.profile', {
    url: STATE_DEFINITION_COMMON['users.profile'].url,
    reloadOnSearch: STATE_DEFINITION_COMMON['users.profile'].reloadOnSearch,
    views: {
      '@': {
        templateUrl: editUrl,
        controller: EditUserProfileCtrl,
        controllerAs: 'ctrl',
      },
    },
    resolve: STATE_DEFINITION_COMMON['users.profile'].resolve,
    onEnter(user, $state) {
      if (!user) {
        $state.go('404', {}, { location: false });
      }
    },
    data: {
      title: '{{ user.fullname }}',
    },
  });

  $stateProvider.state('labor-cost.no-access', {
    url: '/no-access',
    template: '<labor-cost-no-access></labor-cost-no-access>',
    controllerAs: 'ctrl',
  });

  $stateProvider.state('labor-cost.preview', {
    url: '/preview',
    template: `
      <blocks-navigation></blocks-navigation>
      <labor-cost-preview></labor-cost-preview>
    `,
    data: {
      title: 'Preview',
      access: accessLevels.manager,
    },
  });
});

laborCostModule.run(($transitions, Authentication) => {
  $transitions.onStart(
    {
      to: 'labor-cost.**',
    },
    (transition) =>
      managePreviewRedirects(
        Authentication,
        transition,
        'laborCost',
        'labor-cost',
        'labor-cost.settings.tabs'
      )
  );
});

laborCostModule.service('LaborCostSettings', LaborCostSettingsImport);
laborCostModule.factory('LaborSettings', LaborSettingsImport);
laborCostModule.controller('LaborCostCtrl', LaborCostCtrl);
laborCostModule.component('currencySelector', currencySelectorComponent);
laborCostModule.component('laborCostSettings', laborCostSettingsComponent);
laborCostModule.component('laborCostUsers', laborCostUsersComponent);
laborCostModule.component('laborCostNoAccess', laborCostNoAccessComponent);
laborCostModule.component('laborCostPreview', laborCostPreviewComponent);

export default laborCostModule.name;
